import script from "./Authenticate.vue?vue&type=script&setup=true&lang=ts"
export * from "./Authenticate.vue?vue&type=script&setup=true&lang=ts"

import "./Authenticate.vue?vue&type=style&index=0&id=25c4713f&lang=scss&scoped=true"

import exportComponent from "X:\\Git\\Patreon-Linker\\patreon-linker\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25c4713f"]])

export default __exports__